import { SET_COLUMN_STATE, SET_FILTER_STATE } from "./types";

export const acSetColumnState = (tableId, newColumnState) => (dispatch) => {
  dispatch({ type: SET_COLUMN_STATE, payload: { tableId, newColumnState } });
};

export const acSetFilterState = (tableId, newFilterState) => (dispatch) => {
  dispatch({ type: SET_FILTER_STATE, payload: { tableId, newFilterState } });
};
